import Vue from 'vue'
import Router from 'vue-router'

import Profile from './components/screen/Profile'
import profileSync from './components/screen/profile/Sync'
import profileCollection from './components/screen/profile/Collection'
import profileActivity from './components/screen/profile/Activity'
import profileUsers from './components/screen/profile/Users'
import profilePlays from './components/screen/profile/Plays'
import profileRatings from './components/screen/profile/Ratings'

import profileInsightsPlays from './components/screen/profile/insights/Plays'
import profileInsightsRatings from './components/screen/profile/insights/Ratings'
import profileInsightsCollection from './components/screen/profile/insights/Collection'
import profileInsightsShelf from './components/screen/profile/insights/Shelf'
import profileInsightsSize from './components/screen/profile/insights/Size'
import profileInsightsMembers from './components/screen/profile/insights/Members'
import profileInsightsHindex from './components/screen/profile/insights/Hindex'
import profileInsightsRecords from './components/screen/profile/insights/Records'
import profileInsightsWorth from './components/screen/profile/insights/Worth'
import profileInsightsPlayers from './components/screen/profile/insights/Players'
import profileInsightsPlayer from './components/screen/profile/insights/Player'

import profileLists from './components/screen/profile/Lists'
import profileList from './components/screen/profile/List'

import profileTools from './components/screen/profile/Tools'
import profileToolPlayGrid from './components/screen/profile/tool/PlayGrid'
import profileToolHeatmap from './components/screen/profile/tool/Heatmap'
import profileToolWordCloud from './components/screen/profile/tool/WordCloud'

import Home from './components/screen/Home'
import Verify from './components/screen/Verify'
import Reset from './components/screen/Reset'
import Notfound from './components/screen/404'
import ErrorEncounted from './components/screen/Error'

import sessionPatreon from './components/screen/session/Patreon'
import sessionSettings from './components/screen/session/Settings'
import sessionSyncs from './components/screen/session/Syncs'

import sessionPatreonAccess from './components/screen/session/PatreonAccess'
import sessionPatreonBoosts from './components/screen/session/PatreonBoosts'
import sessionPatreonSubdomains from './components/screen/session/PatreonSubdomains'
import sessionPatreonExternaldomains from './components/screen/session/PatreonExternaldomains'
import sessionPatreonSyncs from './components/screen/session/PatreonSyncs'

import communityVoting from './components/screen/community/Voting'
import communityPatreon from './components/screen/community/Patreon'
import communityAccess from './components/screen/community/Access'

import logoutGuard from './router/logout.js'

import qs from 'qs'

Vue.use(Router)

var routes = []

if (process.env.VUE_APP_TYPE === 'subdomain' || process.env.VUE_APP_TYPE === 'externaldomain') {

	routes = [
		{
			path: '/404',
			name: '404',
			component: Notfound,
			meta: {
				title: 'Page not found',
				isStandalone: true
			}
		},
		{
			path: '/error',
			name: 'Error',
			component: ErrorEncounted,
			meta: {
				title: 'Error',
				isStandalone: true
			}
		},
		{
			path: '/logout',
			name: 'Logout',
			component: Home,
			meta: {
				title: 'Logout',
				requireUser: true,
				isStandalone: true
			},
			beforeEnter: logoutGuard
		},
		{
			path: '/verify/:key',
			name: 'Verify',
			component: Verify,
			meta: {
				title: 'Verify',
				requireGuest: true,
				isStandalone: true
			}
		},
		{
			path: '/reset/:key',
			name: 'Reset',
			component: Reset,
			meta: {
				title: 'Reset',
				requireGuest: true,
				isStandalone: true
			}
		},
		{
			path: '/my/settings',
			name: 'SessionSettings',
			component: sessionSettings,
			meta: {
				title: 'Settings',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/syncs',
			name: 'SessionSyncs',
			component: sessionSyncs,
			meta: {
				title: 'Syncs',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon',
			name: 'SessionPatreon',
			component: sessionPatreon,
			meta: {
				title: 'Patreon',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/early-access',
			name: 'SessionPatreonAccess',
			component: sessionPatreonAccess,
			meta: {
				title: 'Patreon - Early Access',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/speed-boosts',
			name: 'SessionPatreonBoosts',
			component: sessionPatreonBoosts,
			meta: {
				title: 'Patreon - Speed Boosts',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/subdomains',
			name: 'SessionPatreonSubdomains',
			component: sessionPatreonSubdomains,
			meta: {
				title: 'Patreon - Subdomains',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/externaldomains',
			name: 'SessionPatreonExternaldomains',
			component: sessionPatreonExternaldomains,
			meta: {
				title: 'Patreon - External Domains',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/feature-voting',
			name: 'SessionPatreonVoting',
			component: communityVoting,
			meta: {
				title: 'Patreon - Feature Voting',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/group-syncs',
			name: 'SessionPatreonSyncs',
			component: sessionPatreonSyncs,
			meta: {
				title: 'Patreon - Group Syncs',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/community/feature-voting',
			name: 'CommunityVoting',
			component: communityVoting,
			meta: {
				isCommunity: true,
				title: 'Feature Voting'
			}
		},
		{
			path: '/community/early-access',
			name: 'CommunityAccess',
			component: communityAccess,
			meta: {
				isCommunity: true,
				title: 'Early Access'
			}
		},
		{
			path: '/community/patreon',
			name: 'CommunityPatreon',
			component: communityPatreon,
			meta: {
				isCommunity: true,
				title: 'Patreon'
			}
		},
		{
			path: '/',
			component: Profile,
			children: [
				{
					path: '',
					name: 'Default',
					component: profileCollection,
					meta: {
						title: 'Collection',
						search: {
							store: 'filter/collection/text',
							placeholder: 'Search collection...'
						}
					}
				},
				{
					path: 'sync',
					name: 'Sync',
					component: profileSync,
					meta: {
						title: 'Sync',
						isStandalone: true
					}
				},
				{
					path: 'collection',
					name: 'Collection',
					component: profileCollection,
					meta: {
						title: 'Collection',
						search: {
							store: 'filter/collection/text',
							placeholder: 'Search collection...'
						}
					}
				},
				{
					path: 'activity',
					name: 'Activity',
					component: profileActivity,
					meta: {
						title: 'Activity'
					}
				},
				{
					path: 'users',
					name: 'Users',
					component: profileUsers,
					meta: {
						title: 'Users'
					}
				},
				{
					path: 'ratings',
					name: 'Ratings',
					component: profileRatings,
					meta: {
						title: 'Ratings',
						search: {
							store: 'filter/ratings/text',
							placeholder: 'Search ratings...'
						}
					}
				},
				{
					path: 'lists',
					name: 'Lists',
					component: profileLists,
					meta: {
						title: 'Lists'
					}
				},
				{
					path: 'lists/:list/:edition',
					name: 'Edition',
					component: profileList,
					meta: {
						title: 'List'
					}
				},
				{
					path: 'lists/:list',
					name: 'List',
					component: profileList,
					meta: {
						title: 'List'
					}
				},
				{
					path: 'plays',
					name: 'Plays',
					component: profilePlays,
					meta: {
						title: 'Plays',
						search: {
							store: 'filter/plays/text',
							placeholder: 'Search plays...'
						}
					}
				},
				{
					path: 'tools',
					name: 'Tools',
					component: profileTools,
					meta: {
						title: 'Tools'
					}
				},
				{
					path: 'tools/play-grid',
					name: 'ToolsPlayGrid',
					component: profileToolPlayGrid,
					meta: {
						title: 'Play Grid | Tools'
					}
				},
				{
					path: 'tools/wordcloud',
					name: 'ToolsWordCloud',
					component: profileToolWordCloud,
					meta: {
						title: 'Word Cloud | Tools'
					}
				},
				{
					path: 'tools/heatmap',
					name: 'ToolsHeatmap',
					component: profileToolHeatmap,
					meta: {
						title: 'Heatmap | Tools'
					}
				},
				{
					path: 'insights',
					name: 'Insights',
					component: profileInsightsCollection,
					meta: {
						title: 'Collection | Insights',
						section: 'collection',
						subtitle: 'Collection'
					}
				},
				{
					path: 'insights/collection/shelf',
					name: 'InsightsShelf',
					component: profileInsightsShelf,
					meta: {
						title: function() {
						
							return 'Shelf of ' + ((this.$store.getters['session/config'].lists.unplayed.type === 'shame') ? 'Shame' : 'Opportunity') + ' | Insights'

						},
						section: 'shelf',
						parenttitle: 'Collection',
						subtitle: 'Shelf of Shame'
					}
				},
				{
					path: 'insights/collection/worth',
					name: 'InsightsWorth',
					component: profileInsightsWorth,
					meta: {
						title: 'Collection Worth | Insights',
						section: 'worth',
						parenttitle: 'Collection',
						subtitle: 'Worth'
					}
				},
				{
					path: 'insights/collection/size',
					name: 'InsightsSize',
					component: profileInsightsSize,
					meta: {
						title: 'Collection Size | Insights',
						section: 'size',
						parenttitle: 'Collection',
						subtitle: 'Size'
					}
				},
				{
					path: 'insights/plays',
					name: 'InsightsPlays',
					component: profileInsightsPlays,
					meta: {
						title: 'Plays | Insights',
						section: 'plays',
						subtitle: 'Plays'
					}
				},
				{
					path: 'insights/collection',
					name: 'InsightsCollection',
					component: profileInsightsCollection,
					meta: {
						title: 'Collection | Insights',
						section: 'collection',
						subtitle: 'Collection'
					}
				},
				{
					path: 'insights/ratings',
					name: 'InsightsRatings',
					component: profileInsightsRatings,
					meta: {
						title: 'Ratings | Insights',
						section: 'ratings',
						subtitle: 'Ratings'
					}
				},
				{
					path: 'insights/members',
					name: 'InsightsMembers',
					component: profileInsightsMembers,
					meta: {
						title: 'Members | Insights',
						section: 'members',
						subtitle: 'Members'
					}
				},
				{
					path: 'insights/plays/players',
					name: 'InsightsPlayers',
					component: profileInsightsPlayers,
					meta: {
						title: 'Friends & Foes | Plays | Insights',
						section: 'players',
						parenttitle: 'Plays',
						subtitle: 'Friends & Foes',
						early: 'friends_and_foes'
					}
				},
				{
					path: 'insights/plays/players/:player',
					name: 'InsightsPlayer',
					component: profileInsightsPlayer,
					meta: {
						title: 'Friends & Foes | Plays | Insights',
						section: 'player',
						parenttitle: 'Plays',
						subtitle: 'Friends & Foes',
						early: 'friends_and_foes'
					}
				},
				{
					path: 'insights/plays/h-index',
					name: 'InsightsHindex',
					component: profileInsightsHindex,
					meta: {
						title: 'Play H-index | Insights',
						section: 'hindex',
						parenttitle: 'Plays',
						subtitle: 'H-index'
					}
				},
				{
					path: 'insights/plays/h-index/:index',
					name: 'InsightsHindexIndex',
					component: profileInsightsHindex,
					meta: {
						title: 'Play H-index | Insights',
						section: 'hindex',
						parenttitle: 'Plays',
						subtitle: 'H-index'
					}
				},
				{
					path: 'insights/plays/streaks-and-records',
					name: 'InsightsRecords',
					component: profileInsightsRecords,
					meta: {
						title: 'Play Streaks & Records | Insights',
						section: 'records',
						parenttitle: 'Plays',
						subtitle: 'Streaks & Records'
					}
				}
			],
			meta: {
				requireVerify: true,
				isProfile: true
			}
		}
	]

} else {

	routes = [
		{
			path: '/',
			name: 'Home',
			component: Home,
			meta: {
				title: 'Home',
				isStandalone: true
			}
		},
		{
			path: '/404',
			name: '404',
			component: Notfound,
			meta: {
				title: 'Page not found',
				isStandalone: true
			}
		},
		{
			path: '/error',
			name: 'Error',
			component: ErrorEncounted,
			meta: {
				title: 'Error',
				isStandalone: true
			}
		},
		{
			path: '/logout',
			name: 'Logout',
			component: Home,
			meta: {
				title: 'Logout',
				requireUser: true,
				isStandalone: true
			},
			beforeEnter: logoutGuard
		},
		{
			path: '/verify/:key',
			name: 'Verify',
			component: Verify,
			meta: {
				title: 'Verify',
				requireGuest: true,
				isStandalone: true
			}
		},
		{
			path: '/reset/:key',
			name: 'Reset',
			component: Reset,
			meta: {
				title: 'Reset',
				requireGuest: true,
				isStandalone: true
			}
		},
		{
			path: '/my/settings',
			name: 'SessionSettings',
			component: sessionSettings,
			meta: {
				title: 'Settings',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/syncs',
			name: 'SessionSyncs',
			component: sessionSyncs,
			meta: {
				title: 'Syncs',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon',
			name: 'SessionPatreon',
			component: sessionPatreon,
			meta: {
				title: 'Patreon',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/early-access',
			name: 'SessionPatreonAccess',
			component: sessionPatreonAccess,
			meta: {
				title: 'Patreon - Early Access',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/speed-boosts',
			name: 'SessionPatreonBoosts',
			component: sessionPatreonBoosts,
			meta: {
				title: 'Patreon - Speed Boosts',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/subdomains',
			name: 'SessionPatreonSubdomains',
			component: sessionPatreonSubdomains,
			meta: {
				title: 'Patreon - Subdomains',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/externaldomains',
			name: 'SessionPatreonExternaldomains',
			component: sessionPatreonExternaldomains,
			meta: {
				title: 'Patreon - External Domains',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/feature-voting',
			name: 'SessionPatreonVoting',
			component: communityVoting,
			meta: {
				title: 'Patreon - Feature Voting',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/group-syncs',
			name: 'SessionPatreonSyncs',
			component: sessionPatreonSyncs,
			meta: {
				title: 'Patreon - Group Syncs',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/community/feature-voting',
			name: 'CommunityVoting',
			component: communityVoting,
			meta: {
				isCommunity: true,
				title: 'Feature Voting'
			}
		},
		{
			path: '/community/early-access',
			name: 'CommunityAccess',
			component: communityAccess,
			meta: {
				isCommunity: true,
				title: 'Early Access'
			}
		},
		{
			path: '/community/patreon',
			name: 'CommunityPatreon',
			component: communityPatreon,
			meta: {
				isCommunity: true,
				title: 'Patreon'
			}
		},
		{
			path: '/:type/:name',
			component: Profile,
			children: [
				{
					path: '',
					name: 'Default',
					component: profileCollection,
					meta: {
						title: 'Collection',
						search: {
							store: 'filter/collection/text',
							placeholder: 'Search collection...'
						}
					}
				},
				{
					path: 'sync',
					name: 'Sync',
					component: profileSync,
					meta: {
						title: 'Sync',
						isStandalone: true
					}
				},
				{
					path: 'collection',
					name: 'Collection',
					component: profileCollection,
					meta: {
						title: 'Collection',
						search: {
							store: 'filter/collection/text',
							placeholder: 'Search collection...'
						}
					}
				},
				{
					path: 'activity',
					name: 'Activity',
					component: profileActivity,
					meta: {
						title: 'Activity'
					}
				},
				{
					path: 'users',
					name: 'Users',
					component: profileUsers,
					meta: {
						title: 'Users'
					}
				},
				{
					path: 'ratings',
					name: 'Ratings',
					component: profileRatings,
					meta: {
						title: 'Ratings',
						search: {
							store: 'filter/ratings/text',
							placeholder: 'Search ratings...'
						}
					}
				},
				{
					path: 'lists',
					name: 'Lists',
					component: profileLists,
					meta: {
						title: 'Lists'
					}
				},
				{
					path: 'lists/:list/:edition',
					name: 'Edition',
					component: profileList,
					meta: {
						title: 'List'
					}
				},
				{
					path: 'lists/:list',
					name: 'List',
					component: profileList,
					meta: {
						title: 'List'
					}
				},
				{
					path: 'plays',
					name: 'Plays',
					component: profilePlays,
					meta: {
						title: 'Plays',
						search: {
							store: 'filter/plays/text',
							placeholder: 'Search plays...'
						}
					}
				},
				{
					path: 'tools',
					name: 'Tools',
					component: profileTools,
					meta: {
						title: 'Tools'
					}
				},
				{
					path: 'tools/play-grid',
					name: 'ToolsPlayGrid',
					component: profileToolPlayGrid,
					meta: {
						title: 'Play Grid | Tools'
					}
				},
				{
					path: 'tools/wordcloud',
					name: 'ToolsWordCloud',
					component: profileToolWordCloud,
					meta: {
						title: 'Word Cloud | Tools'
					}
				},
				{
					path: 'tools/heatmap',
					name: 'ToolsHeatmap',
					component: profileToolHeatmap,
					meta: {
						title: 'Heatmap | Tools'
					}
				},
				{
					path: 'insights',
					name: 'Insights',
					component: profileInsightsCollection,
					meta: {
						title: 'Collection | Insights',
						section: 'collection',
						subtitle: 'Collection'
					}
				},
				{
					path: 'insights/collection/shelf',
					name: 'InsightsShelf',
					component: profileInsightsShelf,
					meta: {
						title: function() {
						
							return 'Shelf of ' + ((this.$store.getters['session/config'].lists.unplayed.type === 'shame') ? 'Shame' : 'Opportunity') + ' | Insights'

						},
						section: 'shelf',
						parenttitle: 'Collection',
						subtitle: 'Shelf of Shame'
					}
				},
				{
					path: 'insights/collection/worth',
					name: 'InsightsWorth',
					component: profileInsightsWorth,
					meta: {
						title: 'Collection Worth | Insights',
						section: 'worth',
						parenttitle: 'Collection',
						subtitle: 'Worth'
					}
				},
				{
					path: 'insights/collection/size',
					name: 'InsightsSize',
					component: profileInsightsSize,
					meta: {
						title: 'Collection Size | Insights',
						section: 'size',
						parenttitle: 'Collection',
						subtitle: 'Size'
					}
				},
				{
					path: 'insights/plays',
					name: 'InsightsPlays',
					component: profileInsightsPlays,
					meta: {
						title: 'Plays | Insights',
						section: 'plays',
						subtitle: 'Plays'
					}
				},
				{
					path: 'insights/plays/players',
					name: 'InsightsPlayers',
					component: profileInsightsPlayers,
					meta: {
						title: 'Friends & Foes | Plays | Insights',
						section: 'players',
						parenttitle: 'Plays',
						subtitle: 'Friends & Foes',
						early: 'friends_and_foes'
					}
				},
				{
					path: 'insights/plays/players/:player',
					name: 'InsightsPlayer',
					component: profileInsightsPlayer,
					meta: {
						title: 'Friends & Foes | Plays | Insights',
						section: 'player',
						parenttitle: 'Plays',
						subtitle: 'Friends & Foes',
						early: 'friends_and_foes'
					}
				},
				{
					path: 'insights/collection',
					name: 'InsightsCollection',
					component: profileInsightsCollection,
					meta: {
						title: 'Collection | Insights',
						section: 'collection',
						subtitle: 'Collection'
					}
				},
				{
					path: 'insights/ratings',
					name: 'InsightsRatings',
					component: profileInsightsRatings,
					meta: {
						title: 'Ratings | Insights',
						section: 'ratings',
						subtitle: 'Ratings'
					}
				},
				{
					path: 'insights/members',
					name: 'InsightsMembers',
					component: profileInsightsMembers,
					meta: {
						title: 'Members | Insights',
						section: 'members',
						subtitle: 'Members'
					}
				},
				{
					path: 'insights/plays/h-index',
					name: 'InsightsHindex',
					component: profileInsightsHindex,
					meta: {
						title: 'Play H-index | Insights',
						section: 'hindex',
						parenttitle: 'Plays',
						subtitle: 'H-index'
					}
				},
				{
					path: 'insights/plays/h-index/:index',
					name: 'InsightsHindexIndex',
					component: profileInsightsHindex,
					meta: {
						title: 'Play H-index | Insights',
						section: 'hindex',
						parenttitle: 'Plays',
						subtitle: 'H-index'
					}
				},
				{
					path: 'insights/plays/streaks-and-records',
					name: 'InsightsRecords',
					component: profileInsightsRecords,
					meta: {
						title: 'Play Streaks & Records | Insights',
						section: 'records',
						parenttitle: 'Plays',
						subtitle: 'Streaks & Records'
					}
				}
			],
			meta: {
				requireVerify: true,
				isProfile: true
			}
		}
	]

}

export default new Router({
	mode: 'history',
	stringifyQuery: function(query) {
		let result = qs.stringify(query, { format: 'RFC1738', arrayFormat: true })
		result = result.replace(/%2C/g, ',')
		result = result.replace(/%2B/g, '+')
		result = result.replace(/%5B/g, '[')
		result = result.replace(/%5D/g, ']')
		result = result.replace(/%3B/g, ';')
		result = result.replace(/%7B/g, '{')
		result = result.replace(/%7D/g, '}')
		result = result.replace(/%21/g, '!')
		return result ? ('?' + result) : ''
	},
	routes: routes
})
